export var ProgramSupportEnum = [
    {
        label: "RES+ Nové obnovitelné zdroje v energetice",
        value: "RES",
    },
    {
        label: "HEAT Modernizace soustav zásobování tepelnou energií",
        value: "HEAT",
    },
    {
        label: "ENERG Energetická účinnost a snižování spotřeby energie",
        value: "ENERG",
    },
    {
        label: "TRANSPORT Modernizace dopravy",
        value: "TRANSPORT",
    },
    {
        label: "GREENGAS Obnovitelná plynná a kapalná paliva",
        value: "GREENGAS",
    },
    {
        label: "SMARTNET Modernizace energetických soustav",
        value: "SMARTNET",
    },
    {
        label: "KOMUNERG Komunitní energetika",
        value: "KOMUNERG",
    },
    {
        label: "I+ Inovativní a komplexní projekty",
        value: "I",
    },
];
